let absPathReg = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;

export function isAbsPath(val) {
	return absPathReg.test(val);
}